import merge from 'lodash/merge';
import {HTMLAttributes, SyntheticEvent} from 'react';
import {UrlLink} from '../../applink/UrlLink';
import {twMerge} from '../../common/twMerge';
import {MOBILE_HEADER_HEIGHT_PX} from '../../header/constants';
import {LOG_CLICK_EVENT} from '../../logging/logEvent';
import {Icon} from '../atoms/Icon/Icon';
import {IconType} from '../atoms/Icon/IconType.enum';

interface MobileLayoutSetOverviewHeader extends HTMLAttributes<HTMLDivElement> {
  seriesId?: string;
  onClickBack: (e: SyntheticEvent) => void;
}

export function MobileLayoutSetOverviewHeader({
  seriesId,
  onClickBack,
  className,
  style,
  ...props
}: MobileLayoutSetOverviewHeader) {
  return (
    <div
      className={twMerge(
        'flex w-full items-center justify-between bg-theme-bg-base px-10pxr',
        className
      )}
      style={merge(
        {
          height: MOBILE_HEADER_HEIGHT_PX,
        },
        style
      )}
      {...props}
    >
      <div>
        <Icon type={IconType.NavigationBack} onClick={onClickBack} />
      </div>
      {seriesId && (
        <UrlLink
          url={`/content/${seriesId}`}
          onClick={e => LOG_CLICK_EVENT('작품홈_클릭', e)}
        >
          <Icon type={IconType.NavigationContentsHome} />
        </UrlLink>
      )}
    </div>
  );
}
